export default __webpack_public_path__ + "static/media/Bone.29047cbb.png";